// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2024-04-16 18:49:22 +0200 (Tue, 16 Apr 2024) $
//  Author    : Albert Charlier, Dirk Rothe, Tobias Schwarzkopf
//  Worker    : $Author: j.maibaum $
//  Revision  : $Rev: 142209 $
//  Purpose   : definition lists
// =============================================================================
// --- Framework imports
import log from 'uix/logging'
import {dict} from 'ldash'

// load from server/config
import languageCodes from '../../../config/codes.xml'
// --- Globals

// index on first access
let CODE_MAP = null

export const translateLangCode = (code, targeti18n) => {
  if (!CODE_MAP) {
    CODE_MAP = dict(
      languageCodes.codes.code.map(e => [e.$['iso639-2'], {de: e.de, en: e.en, fr: e.fr, it: e.it}])
    )
  }

  let res = CODE_MAP[code]
  if (!res) {
    return code
  }
  res = res[targeti18n]
  if (!res) {
    return code + ' ' + targeti18n
  }
  return res
}
